import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { CheckoutAdminEvent } from "src/app/models/enrollment-checkout";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-admin-event',
    templateUrl: './admin-event.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutAdminEventComponent implements OnInit {
    @Input() public checkoutAdminEvent: CheckoutAdminEvent;

    public accept = false;

    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    constructor(
    ) {
    }

    ngOnInit(): void {
    }

    public complete(): void {
        this.emitComplete.emit();
    }
}